<!--
 * @Desc: 校园风光
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-08 14:55:01
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-campus">
        <div class="container">
            <div class="title-hold">
                <div class="title">
                    <img
                        class="pic"
                        src="../../../public/statics/images/Index/campus-title.png"
                    />
                </div>
                <div class="title-more" @click="toMore()">
                    了解更多
                    <img
                        class="thu"
                        src="../../../public/statics/images/arr.png"
                    />
                </div>
            </div>
            <section class="swiper swiper-campus">
                <div class="swiper-wrapper" v-if="listData && listData.article">
                    <div class="swiper-slide" v-for="(item,idx) in listData.article" :key="idx" @click="toDetail(item)">
                        <div class="slide-thu">
                            <img
                                class="thu"
                                :src="$adddom(item.thumb)"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            swiper:''
        };
    },
    computed: {},
    // watch:{
    //     $route(val){
    //         this.pageChange(val.name);
    //     }
    // },
    props:['listData'],
    watch:{
        'listData':function(){
        }
    },
    created: function () {},
    updated: function () {
        let that = this
        this.$nextTick(()=>{
            if (that.swiper) {
                that.swiper.disable()
                that.swiper = ''
            }
            that.swiper = new Swiper(".swiper-campus", {
                slidesPerView: "auto",
                spaceBetween: 20,
                loop: false,
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
            });
        })
    },
    methods: {
        // 跳转更多
        toMore(){
            // console.log(this.listData.url)
            // console.log(this.listData.id)
            this.$toPath(this.listData.url,{
                active:this.listData.id
            })
        },
        /**
         * @name: 跳转详情
         * @param {*} item
         * @return {*}
         * @desc: 跳转详情
         */        
         toDetail(item){
            console.log(item)
            this.$toPath('/NewsDetail?active='+this.listData.id+'&id=' +item.id)
        },
    },
};
</script>

<style scoped>
.page-campus {
    width: 100%;
    height: 461px;
    background: #f0f2f5;
}
.page-campus .container {
    padding-top: 130px;
}
.page-campus .title-hold .title::after {
    width: 169px;
    height: 28px;
    background: url(../../../public/statics/images/Index/campus-desc.png);
}
.swiper {
    width: 100%;
    height: 176px;
    margin-top: 34px;
}

.swiper-slide {
    width: 285px;
    height: 100%;
    box-sizing: border-box;
}
.swiper-slide .slide-thu {
    width: 285px;
    height: 176px;
}
.swiper-slide .slide-thu .thu {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
